import PaymentFile from './payment-file.view.vue';

export default [
  {
    path: '/payment-file',
    name: 'payment-file',
    component: PaymentFile,
  },
];
